/* eslint-disable sonarjs/no-duplicate-string */
const BAGPAGE_LABELS = {
  checkout: {
    bagPage: {
      lbl_header_bag: 'MY BAG',
      lbl_emptyBag_loginIn: 'LOG IN',
      lbl_sfl_savedForLater: 'SAVED FOR LATER',
      lbl_preorder_items_edd: 'Pre-order item estimated to ship by ',
      lbl_sfl_savedLaterButton: 'Saved for Later',
      lbl_orderledger_total: 'Estimated Total',
      lbl_edd_arrivesby: 'Arrives by',
      lbl_coupon_max_quantity_error:
        'You have reached the limit for the number of items in your bag. Please review your cart as some of your items may not have merged.',
      lbl_signin_cta_banner_signin: 'Sign in',
      lbl_estimate_to_arrive: 'Estimated to arrive by',
      lbl_estimated_to_ship: 'Estimated to ship by',
      lbl_preorder_date: 'PREORDER - SHIPS BY',
      lbl_boss_unavailable_confirmation_heading: "We've saved the rest of the items in your bag...",
      lbl_boss_unavailable_confirmation_heading_only_oss_items: 'Update on cart remaining items!',
      lbl_orderledger_free: 'FREE',
      lbl_bagpage_share_cart: 'Share Bag',
      lbl_itemDelete_modalButtonSFL: 'YES, SAVE FOR LATER',
      lbl_itemDelete_modalButtonConfirmDelete: 'NO THANKS',
      lbl_emptyBag_loggedInMsg: 'Uh oh! Looks like you don’t have anything in your bag yet!',
      lbl_emptyBag_notLoggedInMsg: 'Do you have items in your Bag?',
      lbl_sfl_emptySflMsg_1: 'Not ready to buy anything yet?',
      lbl_sfl_emptySflMsg_2: 'You can save it for later and it will appear in this area.',
      lbl_coupon_afterpay_pickup_from: 'Pickup Items from',
      lbl_coupon_afterpay_msg:
        'You have unapplied coupons! To use them on this order, apply them now before continuing to Afterpay.',
      lbl_coupon_unapplied: 'Unapplied Coupons',
      lbl_billing_afterpaySubmit: 'CONTINUE WITH AFTERPAY',
      lbl_applepay_pickUpAt: 'PICKUP AT',
      lbl_applepay_multipleLocations: 'PICKUP AT MULTIPLE LOCATIONS',
      lbl_applepay_subTotal: 'Subtotal',
      lbl_orderledger_giftServices: 'Gift Service',
      lbl_applepay_estimatedTax: 'Est. Tax (final tax at checkout)',
      lbl_applepay_discounts: 'Discounts',
      lbl_orderledger_giftcards: 'Gift Card(s)',
      lbl_applepay_invalid_street_name:
        'The address entered is invalid, please correct the address',
      lbl_applepay_invalid_house_number:
        'The address entered is invalid, please correct the address',
      lbl_applepay_required_city: 'City is required field',
      lbl_applepay_required_state: 'State is required field',
      lbl_applepay_required_postal_code: 'Postal code is required field',
      lbl_applepay_nonEligibleStateErrorMessage: 'Please enter valid 2 character state',
      lbl_applepay_nonEligibleCountryErrorMessage: 'Shipping available in US only',
      lbl_applepay_noLastNameErrorMessage: 'First and Last name fields are required',
      lbl_applepay_noPhoneNumberErrorMessage: 'A valid phone number is required.',
      lbl_applepay_noEmailAddressErrorMessage: 'A valid email address is required.',
      lbl_applepay_invalid_postal_code:
        'The address entered is invalid, please correct the address',
      lbl_orderledger_buyWith: 'Buy With',
      lbl_venmo_proceed_checkout: 'Proceed to checkout with ',
      lbl_login_suggestion_for_sfl: 'Log in to see the items you’ve saved!',
      lbl_saving_for_later_suggestion:
        "Select 'Save for Later' and we'll hold onto your items until you're ready to make a purchase.",
    },
    billing: {
      lbl_orderTotal_threshold_msg:
        'Afterpay is available for orders that total between $[AfterPayMinOrderAmount] - $[AfterPayMaxOrderAmount]. Please select a new payment method.',
    },
    review: {
      lbl_review_afterpaySubmit: 'Submit Order With Afterpay',
    },
  },
  global: {
    cartItemTile: {
      lbl_offer_applied: 'offer(s) applied!',
    },
    generic: {
      lbl_shipping: 'Shipping',
    },
  },
};

export const PLCC_TOP_OF_BAG_LABELS = {
  global: {
    accountDrawer: {
      lbl_checkout_estimated_subtotal: 'Estimated Subtotal when you use ',
      lbl_accountDrawer_myPlaceRewardsCC: 'My Place Rewards Credit Card',
    },
    actions: {
      lbl_apply_now: 'Apply now',
    },
    generic: {
      lbl_learnMore: 'Learn More',
    },
  },
  checkout: {
    billing: {
      lbl_giftcard_applyBtn: 'Apply',
    },
  },
};

export const BOSS_CONFIRMATION_LABELS = {
  global: {
    checkoutConfirmation: {
      lbl_checkoutmodal_continueCheckout: 'CONTINUE TO CHECKOUT',
      lbl_checkoutmodal_backToBag: 'BACK TO BAG',
    },
  },
  checkout: {
    shipping: {
      lbl_sfs_cart_item_error: 'Important message for your cart',
    },
  },
};

export default BAGPAGE_LABELS;
